import { Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { ThemeToggle } from '@/components/common/theme-toggle';
import { InlineHelp } from '@/features/help';
import { APPEARANCE_VARIANTS } from './variants';
import { useAppearance } from './appearance-context';

export function AppearanceRoute(): JSX.Element {
  const { t } = useTranslation();
  const { variant: active, select } = useAppearance();
  return (
    <div className="space-y-6 max-w-6xl">
      <header>
        <h1 className="text-2xl font-semibold">{t('appearance.title')}</h1>
        <p className="mt-2 text-muted-foreground">{t('appearance.description')}</p>
        <InlineHelp articleId="settings.appearance" label={t('help.open')} />
      </header>
      <div className="grid gap-4 sm:grid-cols-2" role="group" aria-label={t('appearance.title')}>
        {APPEARANCE_VARIANTS.map((variant) => (
          <button
            key={variant.id}
            type="button"
            aria-pressed={active.id === variant.id}
            className="appearance-choice rounded-lg border border-border bg-card p-4 text-start focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring aria-pressed:border-primary aria-pressed:ring-2 aria-pressed:ring-primary"
            onClick={() => select(variant.id)}
          >
            <div aria-hidden="true">
              <variant.Preview />
            </div>
            <span className="mt-4 flex items-center justify-between gap-2 font-semibold">
              {t(variant.nameKey)}
              {active.id === variant.id && (
                <span className="flex items-center gap-1 text-sm text-primary">
                  <Check className="size-4" />
                  {t('appearance.active')}
                </span>
              )}
            </span>
            <span className="mt-1 block text-sm text-muted-foreground">
              {t(variant.descriptionKey)}
            </span>
          </button>
        ))}
      </div>
      <p className="text-sm text-muted-foreground">{t('appearance.storage')}</p>
      <div className="flex items-center gap-3 border-t border-border pt-4">
        <span>{t('appearance.colorMode')}</span>
        <ThemeToggle />
      </div>
    </div>
  );
}
